<template>
  <div class="pwd-reset">
    <h1>Passwort Zurücksetzen</h1>
    <p v-if="!request_sent">
      Fordern Sie hier eine Zurücksetzung an. Sie erhalten eine Email mit einem Verifizierungscode, den Sie anschließend
      gemeinsam mit dem neuen Passwort angeben.
    </p>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-text-field
        outlined
        v-if="!show_user_not_found_message"
        :disabled="request_sent"
        v-model="username"
        name="email"
        :rules="emailRules"
        label="Email Adresse"
        placeholder="mustermann@unternehmen.de"
        required
        v-on:input="prop_email()"
      />
      <v-alert outlined dismissible v-model="show_user_not_found_message" type="error">
        Ein Nutzer mit der Email {{ username }} wurde nicht gefunden.
      </v-alert>
      <v-btn outlined v-if="!request_sent" block color="primary" :disabled="!valid" @click="onReset">
        Zurücksetzen
      </v-btn>
      <div v-if="request_sent">
        <p>
          Wir haben Ihnen eine Email mit dem Bestätigungscode geschickt. Dieser ist eine Stunde lang gültig. Bitte geben
          Sie den Code und ein neues Passwort ein.
        </p>
        <v-text-field
          outlined
          v-if="!show_code_mismatch_message"
          v-model="code"
          name="code"
          :rules="codeRules"
          label="Code"
          placeholder="000000"
          required
        />
        <v-alert outlined dismissible v-model="show_code_mismatch_message" type="error">
          Der eingegebene Code stimmt nicht mit dem gesendeten Code überein
        </v-alert>
        <v-text-field
          outlined
          v-model="password"
          :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
          :rules="[
            passwordRules.required,
            passwordRules.mincnt,
            passwordRules.mincap,
            passwordRules.minnum,
            passwordRules.minspc,
          ]"
          :type="passwordVisible ? 'text' : 'password'"
          name="password"
          label="Neues Passwort"
          @click:append="passwordVisible = !passwordVisible"
          required
        />
        <v-btn outlined block color="primary" :disabled="!valid" @click="onResetConfirm">
          Neues Passwort festlegen
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { forgotPassword, forgotPasswordSubmit } from "./auth.js";
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  name: "PasswordResetView",
  props: {
    email: String,
  },
  mounted() {
    if (this.email) {
      this.username = this.email;
    }
  },
  data() {
    return {
      valid: false,
      username: null,
      password: null,
      passwordVisible: false,
      code: null,
      resend_loading: false,
      show_user_not_found_message: false,
      show_code_mismatch_message: false,
      request_sent: false,
    };
  },
  computed: {
    emailRules() {
      return [
        (v) => !!v || "Email ist ein Pflichtfeld",
        (v) => /.+@.+\..+/.test(v) || "Feld muss eine Gültige Email enthalten",
      ];
    },
    codeRules() {
      return [(v) => !!v || "Code wird benötigt", (v) => (v && v.length === 6) || "Code besteht aus 6 Ziffern"];
    },
    passwordRules() {
      return {
        required: (value) => !!value || "Passwort ist ein Pflichtfeld",
        mincnt: (v) => (v && v.length >= 8) || "Mindestens 8 Zeichen",
        mincap: (v) => /[A-Z]/.test(v) || "Mindestens 1 Großbuchstabe",
        minnum: (v) => /[0-9]/.test(v) || "Mindestens 1 Ziffer",
        minspc: (v) =>
          /[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`]/.test(v) ||
          "Mindestens 1 Sonderzeichen (^ $ * . [ ] { } ( ) ? \" ! @ # % & / \ , > < ' : ; | _ ~ `)",
      };
    },
  },
  methods: {
    prop_email() {
      this.$root.$emit("email", this.username);
    },
    onReset() {
      if (this.$refs.form.validate()) {
        //console.log(`RESET PASSWORD username: ${this.username}`);
        forgotPassword(this.username).then((res) => {
          if (res.code) {
            if (res.code === "UserNotFoundException") {
              this.show_user_not_found_message = true;
            } else {
              console.error("not implemented error", res.code);
            }
          } else {
            this.request_sent = true;
          }
        });
      }
    },
    onResetConfirm() {
      if (this.$refs.form.validate()) {
        //console.log(`FORGOT CONFIRM PASSWORD username: ${this.username}`);
        forgotPasswordSubmit(this.username, this.code, this.password).then((res) => {
          if (res.code) {
            if (res.code === "CodeMismatchException") {
              this.show_code_mismatch_message = true;
            } else {
              console.error("not implemented error", res.code);
            }
          } else {
            AmplifyEventBus.$emit("authState", "signIn");
          }
        });
      }
    },
  },
};
</script>
